import React from 'react';
import { useAddGroup } from 'src/components/People/Groups/hooks/useAddGroup';
import { ManageGroupForm } from 'src/components/People/Groups/ManageGroupForm';

interface IAddGroupFormProps {
  corpId: string;
  onSuccess: (groupId: string) => void;
  onCancel: () => void;
}

export const AddGroupForm: React.FC<IAddGroupFormProps> = ({
  corpId,
  onSuccess,
  onCancel,
}) => {
  const { mutate } = useAddGroup({ onSuccess });

  return (
    <ManageGroupForm
      onSubmit={(groupInfo) => mutate(groupInfo, corpId)}
      onCancel={onCancel}
    />
  );
};
